import React, { Component } from 'react'

class Screen2A extends Component {

  render() {

    const { entry, addEntry, language, t } = this.props

    return (
      <main>
        <h3>{t(language, 'hateCrimeDetails')}</h3>
        <label>{t(language, 'crimeDateTime')}
          <input type="text" value={entry.date} onChange={(e) => addEntry('date', null, e)} />
        </label>
        <p className="hint">{t(language, 'dateHint')}</p>
        <label>{t(language, 'crimePlace')}
          <input type="text" value={entry.place} onChange={(e) => addEntry('place', null, e)} />
        </label>
        <p className="hint">{t(language, 'placeHint')}</p>
      </main>
    );
  }
}

export default Screen2A;
